/**
 * <Term hint="Weighted average daily sales (units/day)">Wt. ADS</Term>
 *
 * Marks a short label or abbreviation that needs explaining: dotted underline, hint on hover, and
 * the hint is exposed to screen readers through the abbr title. Used for planner column headers
 * such as Wt. ADS, Gap, IXD and CBM.
 */
import React from 'react';

export const PLANNER_TERMS = {
  share: 'Share of this PO allocated to the FC, from its share of recent sales.',
  wtAds: 'Weighted average daily sales at this FC (units per day; recent days count more).',
  fcStock: 'Units already at this FC.',
  gap: 'Units the FC still needs for the days-of-cover target: required stock minus FC stock and stock already on the way.',
  cbm: 'Cubic metres (m³) of carton volume.',
  ixd: 'Cross-dock (IXD) FC: stock passes through to other FCs instead of being stored.',
  draftReserved: 'PO units already reserved by draft shipment plans (not yet approved).',
  committed: 'PO units in approved shipment plans.',
  unplanned: 'Remaining PO units matched to SKU Master that no plan has reserved yet.',
  freeStock: 'Warehouse stock not reserved by other plans.',
  unplannedAtCreation: 'Matched PO units that were not in any plan when this consolidation was created.',
};

export const Term = ({ hint, children, className = '' }) => (
  <abbr title={hint} className={`cursor-help underline decoration-dotted decoration-gray-400 underline-offset-2 ${className}`}>
    {children}
  </abbr>
);

export default Term;
